import { OktonInput, OktonSelect, OktonTextarea } from '@okton/platform-ui';
import { Divider, VStack, useColorModeValue } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

type FormLiveProps = {
  data?: { nome?: string } | null;
};

export default function CriarLive({ data }: FormLiveProps) {
  const [nome, setNome] = useState('');
  const [dataLive, setDataLive] = useState('');
  const [descricao, setDescricao] = useState('');
  const [plataforma, setPlataforma] = useState('shopee');
  const [apiKey, setApiKey] = useState('');
  const [apiSecret, setApiSecret] = useState('');

  const dividerColor = useColorModeValue('gray.200', 'gray.600');

  useEffect(() => {
    if (data) setNome(data.nome || '');
  }, [data]);

  return (
    <VStack spacing="4">
      <OktonInput
        name="nome"
        label="Título da Live*"
        value={nome}
        onChange={e => setNome(e.target.value)}
      />

      <OktonTextarea
        name="descricao"
        label="Descrição"
        placeholder="Descreva o que será apresentado na live..."
        value={descricao}
        onChange={e => setDescricao(e.target.value)}
        minH="100px"
        resize="none"
      />

      <OktonSelect
        name="plataforma"
        label="Plataforma*"
        value={plataforma}
        onChange={e => setPlataforma(e.target.value)}
        options={[
          { value: 'youtube', label: 'YouTube Live' },
          { value: 'tiktok', label: 'TikTok Live' },
          { value: 'instagram', label: 'Instagram Live' },
          { value: 'facebook', label: 'Facebook Live' },
          { value: 'twitch', label: 'Twitch' },
          { value: 'shopee', label: 'Shopee Live' },
          { value: 'mercadolivre', label: 'Mercado Livre Live' },
          { value: 'custom', label: 'Outro / Custom' },
        ]}
      />

      <OktonInput
        name="dataLive"
        label="Data"
        value={dataLive}
        type="datetime-local"
        onChange={e => setDataLive(e.target.value)}
      />

      <Divider borderColor={dividerColor} />

      <OktonInput
        name="streamUrl"
        label="URL da stream ou Código de Embed (opcional)"
        placeholder="https://youtube.com/watch?v=..."
        value={apiKey}
        onChange={e => setApiKey(e.target.value)}
      />

      <OktonInput
        name="thumbnailUrl"
        label="URL da Thumbnail (opcional)"
        placeholder="https://exemplo.com/imagem.jpg"
        value={apiSecret}
        onChange={e => setApiSecret(e.target.value)}
      />
    </VStack>
  );
}
